import "./OverviewStatusHeader.scss";

import type { MouseEvent, ReactNode } from "react";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

import StatusBlock from "./StatusBlock";

type Props = {
  title: ReactNode;
  headerSuffix?: ReactNode;
  items: Array<{
    title: string;
    status: "Red" | "Yellow" | "Green";
    url: string;
  }>;
  onCopy?: () => void;
  onDelete?: () => void;
  workspaceUrl?: string;
};

// relatively positioned header used in FutureMedicalOverview page
const OverviewStatusHeader = memo(
  ({ title, headerSuffix, items, onCopy, onDelete, workspaceUrl }: Props) => {
    const navigate = useNavigate();

    const handleContextMenu = (e: MouseEvent<HTMLDivElement>) => {
      if (!workspaceUrl) return;

      e.preventDefault();
      window.open(workspaceUrl, "_blank");
    };

    return (
      <div className="status-overview-content">
        <div className="flex">
          <div
            className="status-timeline-header btn btn-status-header txt"
            onClick={() => workspaceUrl && navigate(workspaceUrl)}
            onContextMenu={handleContextMenu}
            style={{ cursor: workspaceUrl ? "pointer" : "default" }}
          >
            {title}
          </div>
          {headerSuffix}
          {onCopy && (
            <div
              className="btn btn-status-header material-icons"
              onClick={onCopy}
            >
              content_copy
            </div>
          )}
          {onDelete && (
            <div
              className="btn btn-status-header material-icons"
              onClick={onDelete}
            >
              delete_outline
            </div>
          )}
        </div>
        <div className="status-timeline flex">
          {items.map(({ title, status, url }) => (
            <StatusBlock key={title} title={title} status={status} url={url} />
          ))}
        </div>
      </div>
    );
  },
);

export default OverviewStatusHeader;
